import script from "./IntroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroSection.vue?vue&type=script&setup=true&lang=ts"

import "./IntroSection.vue?vue&type=style&index=0&id=3f15bf68&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f15bf68"]])

export default __exports__